import type { IPersonCreate } from "../../../../interfaces/models/IPersonCreate";
import { ALL_SOCIAL_URL_FIELD_KEYS, upsertSocialUrl } from "./socialNetworks";
import type { PersonFormAction, PersonFormState } from "./personFormTypes";
import { computeDirtyFields } from "./personFormUtils";

export function createInitialPersonFormState(form: IPersonCreate): PersonFormState {
  const snapshot = { ...form };
  return {
    form: snapshot,
    initialForm: { ...snapshot },
    errors: {},
    touched: {},
    dirtyFields: {},
    submitCount: 0,
  };
}

export function personFormReducer(state: PersonFormState, action: PersonFormAction): PersonFormState {
  switch (action.type) {
    case "INITIALIZE_FORM":
    case "RESET_FORM": {
      const nextForm = { ...action.payload.form };
      return {
        form: nextForm,
        initialForm: { ...nextForm },
        errors: {},
        touched: {},
        dirtyFields: {},
        submitCount: 0,
      };
    }
    case "SET_FIELD": {
      const { field, value } = action.payload;
      const nextForm: IPersonCreate = { ...state.form, [field]: value };
      return {
        ...state,
        form: nextForm,
        dirtyFields: computeDirtyFields(nextForm, state.initialForm),
      };
    }
    case "SET_FORM_PATCH": {
      const nextForm: IPersonCreate = { ...state.form, ...action.payload };
      return {
        ...state,
        form: nextForm,
        dirtyFields: computeDirtyFields(nextForm, state.initialForm),
      };
    }
    case "SET_SOCIAL_NETWORK_URL": {
      const { name, url } = action.payload;
      const nextSocial = upsertSocialUrl(state.form.socialNetworks, name, url);
      const nextForm: IPersonCreate = { ...state.form, socialNetworks: nextSocial };
      const nextErrors = { ...state.errors };
      delete nextErrors.socialNetworks;
      for (const k of ALL_SOCIAL_URL_FIELD_KEYS) {
        delete nextErrors[k];
      }
      return {
        ...state,
        form: nextForm,
        errors: nextErrors,
        dirtyFields: computeDirtyFields(nextForm, state.initialForm),
      };
    }
    case "SET_ERRORS":
      return { ...state, errors: { ...action.payload } };
    case "CLEAR_FIELD_ERROR": {
      const next = { ...state.errors };
      delete next[action.payload];
      return { ...state, errors: next };
    }
    case "CLEAR_ALL_ERRORS":
      return { ...state, errors: {} };
    case "SET_TOUCHED":
      return {
        ...state,
        touched: { ...state.touched, [action.payload.field]: action.payload.touched },
      };
    case "SET_TOUCHED_MANY":
      return { ...state, touched: { ...state.touched, ...action.payload } };
    case "INCREMENT_SUBMIT":
      return { ...state, submitCount: state.submitCount + 1 };
    default:
      return state;
  }
}
